<template>
  <div class="flex min-h-screen flex-col">
    <div class="sticky top-0 z-50 !mb-0 shrink-0">
      <EHeaderMobile
        :back-button="appStore.showBackButton"
        :flush="flushHeader || justifyCenter"
        @back="goBack"
      >
        <template #actions>
          <LanguageSelector />
        </template>
      </EHeaderMobile>
    </div>

    <div
      :class="[
        'mx-auto flex w-full max-w-xl grow flex-col gap-y-8 px-4',
        {
          'justify-between': justifyBetween && !justifyCenter,
          'justify-center': justifyCenter,
        },
      ]"
    >
      <Loading v-if="isLoading" />
      <slot v-else />
    </div>

    <div
      v-if="hasBottom && !isLoading"
      class="sticky bottom-0 z-50 mx-auto w-full max-w-xl shrink-0 bg-gradient-to-t from-[var(--color-surface)] from-0% via-[var(--color-surface)] via-70% to-transparent to-95% p-4"
    >
      <slot name="bottom" />
    </div>
  </div>
</template>

<script setup>
import LanguageSelector from '@/components/LanguageSelector.vue'
import Loading from '@/components/Loading.vue'
import { useGoBack } from '@/composables/useGoBack.js'
import { useAppStore } from '@/stores/AppStore.js'
import { EHeaderMobile } from '@expansivefm/eds'
import { computed, useSlots } from 'vue'

defineProps({
  showHeader: {
    type: Boolean,
    default: true,
  },
  justifyBetween: {
    type: Boolean,
    default: true,
  },
  justifyCenter: {
    type: Boolean,
    default: false,
  },
  justifyCenterWithBottom: {
    type: Boolean,
    default: false,
  },
  flushHeader: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const appStore = useAppStore()
const slots = useSlots()
const { goBack } = useGoBack()

const hasBottom = computed(() => !!slots.bottom)
</script>
